import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Ng2IzitoastService } from 'ng2-izitoast';
import { CatalogosService } from 'src/app/services/catalogos.service';

@Component({
  selector: 'app-codigos-descuento',
  templateUrl: './codigos-descuento.component.html',
  styleUrls: ['./codigos-descuento.component.scss']
})
export class CodigosDescuentoComponent implements OnInit {
  codigos;
  respuestaCodigos;
  data;
  respuestaDetalle:any;
  respuestaUpdate:any;
  respuestaAgregar:any;
  datos;
  codigoId;
  formularioEdit;
  formulario;

  constructor(private _get:CatalogosService,
    private _update:CatalogosService,
    private _agregar:CatalogosService,
    private modalService: NgbModal,
    private iziToast: Ng2IzitoastService,) { }

  ngOnInit(): void {
    this.getCodigosDescuento();
    this.formulario = {
      codigo: '',
      monto: '',
      tipo:'',
    }

    this.formularioEdit = {
      codigo: '',
      monto: '',
      tipo: '',
    }
  }

  getCodigosDescuento(){
    this._get.getCodigosDescuento().subscribe(
      data => {
        this.respuestaCodigos = data;
        if(this.respuestaCodigos.success){
          this.codigos = this.respuestaCodigos.content;
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));  
  }

  agregarDescuento(){
    this.data = {
      'codigo': this.formulario.codigo,
      'monto': this.formulario.monto,
      'tipo': this.formulario.tipo,
    }
  

    this._agregar.agregarDescuento(this.data).subscribe(
      data => {
        this.respuestaAgregar = data;
        if(this.respuestaAgregar.success){
          this.iziToast.show(
            {
                title: 'Se ha agregado correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.formulario.monto = '';
          this.formulario.codigo = '';
          this.dismissAll();
          this.getCodigosDescuento();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  editarCodigo(codigo){
    this.data = {
      'codigo':codigo,
    }
    this._get.getDetalleCodigo(this.data).subscribe(
      data => {
        this.respuestaDetalle = data;
        if(this.respuestaDetalle.success){
          this.datos = this.respuestaDetalle.content;
          this.formularioEdit.codigo = this.datos.codigo;
          this.formularioEdit.monto = this.datos.monto;
          this.formularioEdit.tipo = this.datos.tipo;
          this.codigoId = this.datos.id;
          document.getElementById('clickEditar').click();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error)
    ) 
  }

  updateCodigoDescuento(codigo){
    this.data = {
      'codigo_descuento':codigo,
      'monto':this.formularioEdit.monto,
      'codigo':this.formularioEdit.codigo,
      'tipo':this.formularioEdit.tipo,
    }
   
    this._update.updateCodigoDescuento(this.data).subscribe(
      data => {
        this.respuestaUpdate = data;
        if(this.respuestaUpdate.success){
          this.iziToast.show(
            {
                title: 'Se ha actualizado correctamente.',
                titleColor: '#f8f8ff',
                color: '#4CAF50',
                position: 'topRight',
                closeOnEscape: true,
            });
          this.dismissAll();
          this.getCodigosDescuento();
        }else {
          alert('No se cargaron los datos');
        }
      }, error => console.error(error));
  }

  openModal(modal) {
    this.modalService.open(modal, { size: 'lg' });
  }

  dismissAll() {
    this.modalService.dismissAll();
  }

}
